/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/

import PropTypes from "prop-types";
import React from "react";
import { IconsCalendar1 } from "../../icons/IconsCalendar1";
import "./style.css";

export const ButtonSmall = ({
  texto = "Lorem ipsum",
  tipo,
  estado,
  iconLeft,
  iconRigth,
  className,
  textClassName,
}) => {
  return (
    <div className={`button-small ${tipo} ${estado} ${className}`}>
      <div
        className={`content-2 icon-left-${iconLeft} icon-rigth-${iconRigth}`}
      >
        {!iconLeft && !iconRigth && (
          <div className={`text ${textClassName}`}>{texto}</div>
        )}

        {iconRigth && <div className={`text-2 ${textClassName}`}>{texto}</div>}

        {(iconLeft || iconRigth) && (
          <IconsCalendar1
            className="icons-calendar"
            color={
              estado === "activo" && tipo === "primario"
                ? "white"
                : estado === "inactivo" &&
                    ["primario", "secundario"].includes(tipo)
                  ? "#969696"
                  : tipo === "link" && estado === "inactivo"
                    ? "#ABABAB"
                    : "#6773E5"
            }
          />
        )}

        {iconLeft && <div className="text-3">{texto}</div>}
      </div>
    </div>
  );
};

ButtonSmall.propTypes = {
  texto: PropTypes.string,
  tipo: PropTypes.oneOf(["link", "secundario", "primario"]),
  estado: PropTypes.oneOf(["activo", "inactivo"]),
  iconLeft: PropTypes.bool,
  iconRigth: PropTypes.bool,
};
